// Phase MHM-5.3 · Sub-nav for micro_hub_lead portal.
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Package, Building2, Boxes, LifeBuoy, Users, ClipboardCheck } from "lucide-react";

const TABS = [
  { to: "/dashboard/micro-hub",                 label: "Dashboard",  Icon: LayoutDashboard, testid: "microlead-tab-dashboard", end: true },
  { to: "/dashboard/micro-hub/orders",          label: "Hub Orders", Icon: Package,         testid: "microlead-tab-orders" },
  { to: "/dashboard/micro-hub/workers",         label: "Workers",    Icon: Users,           testid: "microlead-tab-workers" },
  { to: "/dashboard/micro-hub/worker-requests", label: "Worker Requests", Icon: ClipboardCheck, testid: "microlead-tab-worker-requests" },
  { to: "/dashboard/micro-hub/profile",         label: "My Micro Hub", Icon: Building2,     testid: "microlead-tab-profile" },
  { to: "/dashboard/micro-hub/inventory",       label: "Inventory",  Icon: Boxes,           testid: "microlead-tab-inventory" },
  { to: "/dashboard/micro-hub/tickets",         label: "Tickets",    Icon: LifeBuoy,        testid: "microlead-tab-tickets" },
];

// MHM-5.4 build stamp — evaluated once when this module loads into the tab.
// If a user's tab shows a stamp older than the latest deployment, their bundle is stale.
// Bumped from MHM-5.4-r0 → PACKER-1.0-r1 with the packer staff portal ship;
// → PACKER-1.0-r2 with the session-fresh photo gate fix.
const BUILD_STAMP = "APP-1.0-r7";

export default function MicroLeadSubNav() {
  return (
    <div className="border-b border-slate-200 bg-white sticky top-0 z-30" data-testid="microlead-subnav">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-3 flex flex-wrap items-center gap-2">
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mr-3">
          Micro hub portal
        </div>
        {TABS.map(({ to, label, Icon, testid, end }) => (
          <NavLink key={to} to={to} end={end} data-testid={testid}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm transition-colors ` +
              (isActive
                ? "bg-[#FF6B00] text-white shadow-sm"
                : "bg-slate-100 hover:bg-slate-200 text-slate-700")
            }>
            <Icon className="h-4 w-4" />{label}
          </NavLink>
        ))}
        <span className="ml-auto text-[10px] font-mono text-slate-400"
              title="If this tag is older than the latest release, hard-refresh (Ctrl+Shift+R) to load the newest bundle."
              data-testid="build-stamp"
              data-microlead-build-stamp="true">
          {BUILD_STAMP}
        </span>
      </div>
    </div>
  );
}
